const KEY = "recentApiErrors";
const LIMIT = 10;

function read() {
  try {
    const list = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(list) ? list : [];
  } catch (e) {
    return [];
  }
}

/**
 * The last API errors the user saw, kept in the browser so the AI chat can tell what just went wrong.
 * Only the time, status, path (no query string) and the message: never a request body or a token.
 */
export function recordApiError({ url, status, message }) {
  if (!message) return;
  const list = read();
  list.push({
    time: new Date().toISOString(),
    status: status || 0,
    path: String(url || "").split("?")[0],
    message: String(message).slice(0, 300),
  });
  try {
    localStorage.setItem(KEY, JSON.stringify(list.slice(-LIMIT)));
  } catch (e) {
    // storage full or blocked: the chat just gets no errors
  }
}

export function getRecentApiErrors() {
  return read();
}

export function clearApiErrors() {
  try {
    localStorage.removeItem(KEY);
  } catch (e) {
    // nothing to clear
  }
}
